<template>
  <div
    class="h-screen h-full auth-wrapper flex justify-content-center align-items-center p-fluid"
  >
    <div class="back-auth-form content text-center">
      <h2>Панель керування</h2>

      <AuthForm />
    </div>
  </div>
</template>

<script>
import AuthForm from "@/components/admin/auth/AuthForm.vue";

import filters from "@/config/filters.yml";

import { mapGetters, mapState } from "vuex";

export default {
  name: "ManagerAuthView",
  components: {
    AuthForm,
  },
  data() {
    return {
      filterByID: {
        field: filters.departaments.filterByID,
        value: null,
      },
      filters: {
        pageSize: -1,
      },
    };
  },
  computed: {
    ...mapState({
      department: (state) => state.public_departments.department,
    }),
    ...mapGetters(["departmentByField", "isAdmin", "adminTokenIsValid"]),
  },
  async mounted() {
    if (this.adminTokenIsValid) {
      this.$route.meta.isAdmin && this.isAdmin
        ? this.$router.push({ name: "admin-posts" })
        : this.$router.push({ name: "posts" });
    }
  },
};
</script>
